"use client";

import { ArrowRightLeftIcon } from "lucide-react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

export function NavWorkflows({
  onNavigate,
  activePage,
}: {
  onNavigate: (page: string) => void;
  activePage: string;
}) {
  const workflowItems = [
    {
      name: "My Flows",
      id: "my-flows",
      url: "#",
      icon: ArrowRightLeftIcon,
    },
  ];

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Select workflows</SidebarGroupLabel>
      <SidebarGroupContent className="py-0.5">
        <SidebarMenu>
          {workflowItems.map((item) => (
            <SidebarMenuItem key={item.name}>
              <SidebarMenuButton
                asChild
                isActive={activePage === item.id}
                onClick={() => onNavigate(item.id)}
              >
                <a href={item.url} onClick={(e) => e.preventDefault()}>
                  <item.icon />
                  <span>{item.name}</span>
                </a>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
